import type { QueryParam } from "@ceeferenderer/fe-renderer-sdk";
import { Response } from "./handleResponse";
import { azureTokenInfo } from "../utils/azureTokenInfo";
import { itgExecution } from "./itgExecution";
import { queryParam } from "./queryParam";
import { templateFlowEngine } from "../constants/elements";

const templateString = templateFlowEngine !== undefined ? templateFlowEngine.innerHTML : templateFlowEngine;

export const transform = async (data?: Partial<QueryParam>): Promise<Response> =>
  itgExecution.transform(
    {
      headers: {
        AuthType: "AzureAD",
        Authorization: `Bearer ${(await azureTokenInfo).access_token}`,
        "Content-Type": "application/json",
      },
      payload: {
        ...queryParam,
        applicationName: "Retail",
        cssApplicationName: "FESDK",
        ...(data && {
          displayFormReferenceKey: data.displayFormReferenceKey,
          sessionId: data?.sessionId,
          stepId: data?.stepId,
          ...data[data?.displayFormReferenceKey],
        }),
        retainState:
          data && data[data?.displayFormReferenceKey] && data[data?.displayFormReferenceKey]?.isReasonChanged
            ? !JSON.parse(data[data?.displayFormReferenceKey]?.isReasonChanged)
            : true,
      },
    },
    templateString,
    true
  );
